import { generateSampleIdsApi } from "@/api/va-order-page/orderTest";

// get samplePrice map and sampleIdJulienBarcode map for plan & save order
export async function getOrderSamplePriceMaps(priceList) {
  // generate sample ids according to how many prices in priceList
  let numOfSamples = priceList.length;
  let { data } = await generateSampleIdsApi({ quantity: numOfSamples });
  // convert data to a map
  // given data: [{ sampleId : Number, julienBarcode: String }]
  let sampleIdJulienBarcodeMap = {};
  data.forEach(obj => {
    sampleIdJulienBarcodeMap[obj.sampleId] = obj.julienBarcode;
  })
  let sampleIds = Object.keys(sampleIdJulienBarcodeMap);
  // match sampleIds and priceList to form a samplePriceMap
  let samplePriceMap = {};
  sampleIds.forEach((id, index) => {
    samplePriceMap[id] = priceList[index].toFixed(2);
  });
  return { sampleIdJulienBarcodeMap, samplePriceMap };
}

export function getChargeDetailsForPayOrdersApi(sampleList, isUseCredit, creditAmount, chargeType, customerUsedCredit=0) {
  let remainingCredit = isUseCredit ? customerUsedCredit : 0;
  let chargeDetails = [];
  sampleList.forEach(sample => {
    let price = Number(sample.balance);
    let usedCredit = Math.min(remainingCredit, price);
    chargeDetails.push({
      charge_type: chargeType,
      charge_type_id: sample.orderId,
      sample_id: Number(sample.sample_id),
      price: Number((price - usedCredit).toFixed(2)),
    });
    // update remaining credit
    remainingCredit -= usedCredit;
  })
  return chargeDetails;
}

// credit card type and logos
export function processCardLogo(cardType, isSelect) {
  let typeLowerCase = cardType.toLowerCase();
  switch(typeLowerCase) {
    case "visa":
      return isSelect ? "visa-select.svg" : "visa-not-select.svg";
    case "mastercard":
      return isSelect ? "mastercard-select.svg" : "mastercard-not-select.svg";
    case "discover":
      return isSelect ? "discover-select.svg" : "discover-not-select.svg";
    case "american express":
    case "amex":
      return isSelect ? "american-express-select.svg" : "american-express-not-select.svg";
    default:
      return "";
  }
}